import styled, { css } from 'styled-components'
import { fonts } from 'app/common/typography'
import { media } from 'app/assets/styles/breakpoints'

const titleMixin = css`
    margin: 0;
    font-family: ${props => (props.font ? props.font : fonts.flameRegular)};
    color: ${props => (props.color ? props.color : 'inherit')};
    ${props => props.center && 'text-align: center'};
    ${props => props.underline && 'text-decoration: underline;'};
`

export const styleH1 = css`
    ${titleMixin};
    font-size: 32px;
    ${media.medium`
        font-size: 46px;
    `};
`

export const styleH2 = css`
    ${titleMixin};
    font-size: 26px;
    ${media.medium`
        font-size: 38px;
    `};
`

export const styleH3 = css`
    ${titleMixin};
    font-size: 22px;
    ${media.medium`
        font-size: 32px;
    `};
`

export const styleH4 = css`
    ${titleMixin};
    font-size: 18px;
    ${media.medium`
        font-size: 26px;
    `};
`

export const styleH5 = css`
    ${titleMixin};
    font-size: 16px;
    ${media.medium`
        font-size: 24px;
    `};
`

export const styleH6 = css`
    ${titleMixin};
    font-size: 14px;
    ${media.medium`
        font-size: 22px;
    `};
`

export const H1 = styled.h1`
    ${styleH1};
`

export const H2 = styled.h2`
    ${styleH2};
`

export const H3 = styled.h3`
    ${styleH3};
`

export const H4 = styled.h4`
    ${styleH4};
`

export const H5 = styled.h5`
    ${styleH5};
`

export const H6 = styled.h6`
    ${styleH6};
`
